import {defineAsyncComponent} from 'vue';

const estimateArrgrateProject = defineAsyncComponent(() =>
  import('@/views/estimateArrgrate/beginYearEstimateArrgrate/estimateArrgrateProject/EstimateArrgrateProject.vue'),
);
const estimateArrgrateRegular = defineAsyncComponent(() =>
  import('@/views/estimateArrgrate/beginYearEstimateArrgrate/estimateArrgrateRegular/EstimateArrgrateRegular.vue'),
);
const estimateArrgrateRegularSTC = defineAsyncComponent(() =>
  import('@/views/estimateArrgrate/beginYearEstimateArrgrate/estimateArrgrateRegular/EstimateArrgrateRegularSTC.vue'),
);
const estimateArrgrateMasterTab = defineAsyncComponent(() =>
  import('@/views/estimateArrgrate/beginYearEstimateArrgrate/tabEstimateArrgrate/EstimateArrgrateMasterTab.vue'),
);
const estimateArrgrateDetailTab = defineAsyncComponent(() =>
  import('@/views/estimateArrgrate/beginYearEstimateArrgrate/tabEstimateArrgrate/EstimateArrgrateDetailTab.vue'),
);
const estimateArrgrateExplanation = defineAsyncComponent(() =>
  import('@/views/estimateArrgrate/beginYearEstimateArrgrate/tabEstimateArrgrate/EstimateArrgrateExplanation.vue'),
);
const estimateArrgrateReferencesTab = defineAsyncComponent(() =>
  import('@/views/estimateArrgrate/beginYearEstimateArrgrate/tabEstimateArrgrate/EstimateArrgrateReferencesTab.vue'),
);
const estimateArrgrateRegularField = defineAsyncComponent(() =>
  import('@/views/estimateArrgrate/beginYearEstimateArrgrate/estimateArrgrateRegular/EstimateArrgrateRegularField.vue'),
);

const EstimateArrgrateBudget = defineAsyncComponent(() =>
  import('@/views/estimateArrgrate/beginYearEstimateArrgrate/estimateArrgrateBudget/EstimateArrgrateBudget.vue'),
);
const EstimateArrgrateBudgetSTC = defineAsyncComponent(() =>
  import('@/views/estimateArrgrate/beginYearEstimateArrgrate/estimateArrgrateBudget/EstimateArrgrateBudgetSTC.vue'),
);
const EstimateArrgrateBudgetDetail = defineAsyncComponent(() =>
  import('@/views/estimateArrgrate/beginYearEstimateArrgrate/estimateArrgrateBudget/ArrgrateBudgetDetail.vue'),
);
const EstimateArrgrateBudgetDetailAgency = defineAsyncComponent(() =>
  import('@/views/estimateArrgrate/beginYearEstimateArrgrate/estimateArrgrateBudget/ArrgrateBudgetDetailAgency.vue'),
);

const ArrgrateBudgetDetailAgencySTC = defineAsyncComponent(() =>
  import('@/views/estimateArrgrate/beginYearEstimateArrgrate/estimateArrgrateBudget/ArrgrateBudgetDetailAgencySTC.vue'),
);

const estimateArrgrateExplanationPopup = defineAsyncComponent(() =>
  import('@/views/estimateArrgrate/beginYearEstimateArrgrate/popups/ExplanationPopup.vue'),
);

const explanationArrgratePopup = defineAsyncComponent(() =>
  import('@/views/estimateArrgrate/beginYearEstimateArrgrate/popups/ExplanationArrgratePopup.vue'),
);
const submitExplanationArrgratePopup = defineAsyncComponent(() =>
  import('@/views/estimateArrgrate/beginYearEstimateArrgrate/popups/SubmitExplanationArrgratePopup.vue'),
);
const estimateDetailArrgrateExplanationPopup = defineAsyncComponent(() =>
  import('@/views/estimateArrgrate/beginYearEstimateArrgrate/popups/EstimateDetailArrgrateExplanationPopup.vue'),
);

const explanationSalaryPopup = defineAsyncComponent(() =>
  import('@/views/estimateArrgrate/beginYearEstimateArrgrate/popups/ExplanationSalaryPopup.vue'),
);

const explanationSalaryArrgratePopup = defineAsyncComponent(() =>
  import('@/views/estimateArrgrate/beginYearEstimateArrgrate/popups/ExplanationSalaryArrgratePopup.vue'),
);

const explanationSalarySTCPopup = defineAsyncComponent(() =>
  import('@/views/estimateArrgrate/beginYearEstimateArrgrate/popups/ExplanationSalarySTCPopup.vue'),
);
const EstimateArrgrateExpenseOther = defineAsyncComponent(() =>
  import(
    '@/views/estimateArrgrate/beginYearEstimateArrgrate/estimateArrgrateExpenseOther/EstimateArrgrateExpenseOther.vue'
  ),
);
const EstimateArrgrateExpenseOtherSTC = defineAsyncComponent(() =>
  import(
    '@/views/estimateArrgrate/beginYearEstimateArrgrate/estimateArrgrateExpenseOtherSTC/EstimateArrgrateExpenseOtherSTC.vue'
  ),
);
const EstimateArrgrateOtherExplanationPopup = defineAsyncComponent(() =>
  import(
    '@/views/estimateArrgrate/beginYearEstimateArrgrate/estimateArrgrateExpenseOther/popups/ExplanationExpenseOtherPopup.vue'
  ),
);
const EstimateArrgrateOtherSTCExplanationPopup = defineAsyncComponent(() =>
  import(
    '@/views/estimateArrgrate/beginYearEstimateArrgrate/estimateArrgrateExpenseOtherSTC/popups/ExplanationExpenseOtherSTCPopup.vue'
  ),
);
const EstimateArrgrateOtherExplanationSTCPopup = defineAsyncComponent(() =>
  import(
    '@/views/estimateArrgrate/beginYearEstimateArrgrate/estimateArrgrateExpenseOtherSTC/popups/ExplanationExpenseOtherSTCPopup.vue'
  ),
);
const EstimateArrgrateExpenseInvest = defineAsyncComponent(() =>
  import(
    '@/views/estimateArrgrate/beginYearEstimateArrgrate/estimateArrgrateExpenseInvest/EstimateArrgrateExpenseInvest.vue'
  ),
);
const EstimateArrgrateExpenseInvestSTC = defineAsyncComponent(() =>
  import('@/views/estimateArrgrateSTC/EstimateArrgrateExpenseInvestSTC.vue'),
);
const estimateArrgrateRevenueOther = defineAsyncComponent(() =>
  import(
    '@/views/estimateArrgrate/beginYearEstimateArrgrate/estimateArrgrateRevenueOther/EstimateArrgrateRevenueOther.vue'
  ),
);
const estimateArrgrateRevenueOtherSTC = defineAsyncComponent(() =>
  import(
    '@/views/estimateArrgrate/beginYearEstimateArrgrate/estimateArrgrateRevenueOther/EstimateArrgrateRevenueOtherSTC.vue'
  ),
);
const EstimateArrgrateRevenueOtherDetail = defineAsyncComponent(() =>
  import('@/views/estimateArrgrate/estimateArrgrateDetail/EstimateArrgrateRevenueOtherDetail.vue'),
);

const SummaryEstimateArrgrateExpenseInvest = defineAsyncComponent(() =>
  import('@/views/estimateArrgrate/estimateArrgrateDetail/SummaryEstimateArrgrateExpenseInvest.vue'),
);
const EstimateArrgrateExpenseOtherDetail = defineAsyncComponent(() =>
  import('@/views/estimateArrgrate/estimateArrgrateDetail/EstimateArrgrateExpenseOtherDetail.vue'),
);

const SummaryEstimateArrgrateExpenseProjectDetail = defineAsyncComponent(() =>
  import('@/views/estimateArrgrate/estimateArrgrateDetail/SummaryEstimateArrgrateExpenseProjectDetail.vue'),
);

const SummaryEstimateArrgrateBudgetDetail = defineAsyncComponent(() =>
  import('@/views/estimateArrgrate/estimateArrgrateDetail/SummaryEstimateArrgrateBudgetDetail.vue'),
);

const SummaryEstimateArrgrateBudgetDetailAgency = defineAsyncComponent(() =>
  import('@/views/estimateArrgrate/estimateArrgrateDetail/SummaryEstimateArrgrateBudgetDetailAgency.vue'),
);

const estimateArrgrateRegularSummaryExplanation = defineAsyncComponent(() =>
  import(
    '@/views/estimateArrgrate/beginYearEstimateArrgrate/estimateArrgrateRegular/EstimateArrgrateRegularSummaryExplanation.vue'
  ),
);
const estimateArrgrateRegularSummaryExplanationSTC = defineAsyncComponent(() =>
  import(
    '@/views/estimateArrgrate/beginYearEstimateArrgrate/estimateArrgrateRegular/EstimateArrgrateRegularSummaryExplanationSTC.vue'
  ),
);

const estimateArrgrateExplanationSalarySummary = defineAsyncComponent(() =>
  import('@/views/estimateArrgrate/beginYearEstimateArrgrate/estimateArrgrateRegular/ExplanationSalarySummary.vue'),
);
const estimateArrgrateExplanationSalarySummarySTC = defineAsyncComponent(() =>
  import('@/views/estimateArrgrate/beginYearEstimateArrgrate/estimateArrgrateRegular/ExplanationSalarySummarySTC.vue'),
);

const SummaryEstimateArrgrateCalculationBasisDetail = defineAsyncComponent(() =>
  import('@/views/estimateArrgrate/estimateArrgrateDetail/SummaryEstimateArrgrateCalculationBasisDetail.vue'),
);

const summaryEstimateArrgrateRevenueBussinessDetail = defineAsyncComponent(() =>
  import('@/views/estimateSectorWide/summaryEstimate/SummaryEstimateArrgrateRevenueBussinessDetail.vue'),
);
const summaryEstimateArrgrateExpenseBussinessDetail = defineAsyncComponent(() =>
  import('@/views/estimateSectorWide/summaryEstimate/SummaryEstimateArrgrateExpenseBussinessDetail.vue'),
);
const summaryEstimateArrgrateRevenueFeesDetail = defineAsyncComponent(() =>
  import('@/views/estimateSectorWide/summaryEstimate/SummaryEstimateArrgrateRevenueFeesDetail.vue'),
);
const summaryEstimateArrgrateExpenseFeesDetail = defineAsyncComponent(() =>
  import('@/views/estimateSectorWide/summaryEstimate/SummaryEstimateArrgrateExpenseFeesDetail.vue'),
);
const SummaryEstimateArrgrateExpenseRegularDetail = defineAsyncComponent(() =>
  import('@/views/estimateArrgrate/estimateArrgrateDetail/SummaryEstimateArrgrateExpenseRegularDetail.vue'),
);

const SummaryEstimateArrgrateExpenseRegularDetailSTC = defineAsyncComponent(() =>
  import('@/views/estimateSectorWide/summaryEstimate/SummaryEstimateArrgrateExpenseRegularDetailSTC.vue'),
);

const summaryEstimateArrgrateExpenseInvestWideDetail = defineAsyncComponent(() =>
  import('@/views/estimateSectorWide/summaryEstimate/SummaryEstimateArrgrateExpenseInvestDetail.vue'),
);

const summaryEstimateArrgrateExpenseProjectWideDetail = defineAsyncComponent(() =>
  import('@/views/estimateSectorWide/summaryEstimate/SummaryEstimateArrgrateExpenseProjectDetail.vue'),
);

const summaryEstimateArrgrateExpenseRegularWideDetail = defineAsyncComponent(() =>
  import('@/views/estimateSectorWide/summaryEstimate/SummaryEstimateArrgrateExpenseRegularDetail.vue'),
);

const summaryEstimateArrgrateCalculationBasisWideDetail = defineAsyncComponent(() =>
  import('@/views/estimateSectorWide/summaryEstimate/SummaryEstimateArrgrateCalculationBasisWideDetail.vue'),
);

const summaryEstimateArrgrateRevenueBudgetStcDetailAgency = defineAsyncComponent(() =>
  import('@/views/estimateArrgrateSTC/SummaryEstimateArrgrateRevenueBudgetStcDetailAgency.vue'),
);

const summaryEstimateArrgrateRevenueBudgetStc = defineAsyncComponent(() =>
  import('@/views/estimateArrgrateSTC/SummaryEstimateArrgrateRevenueBudgetStc.vue'),
);

const summaryEstimateArrgrateRevenueOtherStc = defineAsyncComponent(() =>
  import('@/views/estimateArrgrateSTC/SummaryEstimateArrgrateRevenueOtherStc.vue'),
);

// submit estimate
const estimateArrgrateSubmitDetailPopup = defineAsyncComponent(() =>
  import('@/views/estimateArrgrate/beginYearEstimateArrgrate/tabs/popup/EstimateSubmitArrgrateDetailPopup.vue'),
);
const submitArrgrateInvestDetail = defineAsyncComponent(() =>
  import('@/views/submit/estimateArrgrateInvest/SubmitArrgrateInvestDetail.vue'),
);
const submitArrgrateInvestBudgetDetail = defineAsyncComponent(() =>
  import('@/views/submit/estimateArrgrateInvest/SubmitArrgrateInvestBudgetDetail.vue'),
);

const submitArrgrateProjectDetail = defineAsyncComponent(() =>
  import('@/views/submit/estimateArrgrateProject/SubmitArrgrateProjectDetail.vue'),
);

const submitArrgrateCalculationBasisDetail = defineAsyncComponent(() =>
  import('@/views/submit/estimateArrgrate/SubmitArrgrateCalculationBasisDetail.vue'),
);

const submitArrgrateRegularExpenseDetail = defineAsyncComponent(() =>
  import('@/views/submit/estimateArrgrate/SubmitArrgrateRegularExpenseDetail.vue'),
);

const SubmitArrgrateExplanationRegularPopup = defineAsyncComponent(() =>
  import('@/views/submit/popup/SubmitArrgrateExplanationRegularPopup.vue'),
);

const submitArrgrateBudgetDetail = defineAsyncComponent(() =>
  import('@/views/submit/estimateArrgrateBudget/SubmitArrgrateBudgetDetail.vue'),
);

const submitArrgrateBudgetDetailAgency = defineAsyncComponent(() =>
  import('@/views/submit/estimateArrgrateBudget/SubmitArrgrateBudgetDetailAgency.vue'),
);

const submitArrgrateRevenueOtherDetail = defineAsyncComponent(() =>
  import('@/views/submit/estimateArrgrateRevenueOther/SubmitArrgrateRevenueOtherDetail.vue'),
);

const submitArrgrateExpenseOtherDetail = defineAsyncComponent(() =>
  import('@/views/submit/estimateArrgrateInvest/SubmitArrgrateExpenseOtherDetail.vue'),
);

const auditReceiveArrgrateInvestDetail = defineAsyncComponent(() =>
  import('@/views/auditReceive/AuditReceiveArrgrateInvestDetail.vue'),
);
const auditReceiveArrgrateInvestBudgetDetail = defineAsyncComponent(() =>
  import('@/views/auditReceive/AuditReceiveArrgrateInvestBudgetDetail.vue'),
);
const auditReceiveArrgrateProjectDetail = defineAsyncComponent(() =>
  import('@/views/auditReceive/AuditReceiveArrgrateProjectDetail.vue'),
);
const auditReceiveArrgrateCalculationBasisDetail = defineAsyncComponent(() =>
  import('@/views/auditReceive/AuditReceiveArrgrateCalculationBasisDetail.vue'),
);
const AuditReceiveArrgrateRegularDetail = defineAsyncComponent(() =>
  import('@/views/auditReceive/AuditReceiveArrgrateRegularDetail.vue'),
);

const AuditReceiveArrgrateExplanationRegularPopup = defineAsyncComponent(() =>
  import('@/views/auditReceive/AuditReceiveArrgrateExplanationRegularPopup.vue'),
);

const EstimateArrgrateProjectSTC = defineAsyncComponent(() =>
  import(
    '@/views/estimateArrgrate/beginYearEstimateArrgrate/estimateArrgrateProjectSTC/EstimateArrgrateProjectSTC.vue'
  ),
);

const EstimateFinanceThreeYearExpenseInvestDetail = defineAsyncComponent(() =>
  import(
    '@/views/estimateFinanceThreeYear/tabs/createEstimate/expenseInvest/EstimateFinanceThreeYearExpenseInvestDetail.vue'
  ),
);

const SummaryEstimateArrgrateExpenseOtherDetailSTC = defineAsyncComponent(() =>
  import('@/views/estimateArrgrate/estimateArrgrateDetail/SummaryEstimateArrgrateExpenseOtherDetailSTC.vue'),
);

const SummaryEstimateArrgrateOtherSTCExplanationPopup = defineAsyncComponent(() =>
  import('@/views/estimateArrgrate/estimateArrgrateDetail/popup/SummaryEstimateArrgrateOtherSTCExplanationPopup.vue'),
);

const AllocationImplementBudgetDetailAgency = defineAsyncComponent(() =>
  import('@/views/allocationImplement/details/popup/AllocationImplementBudgetDetailAgency.vue'),
);
const AllocationImplementBudgetDetailAgencyPTC = defineAsyncComponent(() =>
  import('@/views/allocationImplement/details/popup/AllocationImplementBudgetDetailAgencyPTC.vue'),
);

// Các màn chi tiết dự toán nộp STC
const estimateSubmitArrgrateSTCDetailPopup = defineAsyncComponent(() =>
  import('@/views/estimateArrgrate/beginYearEstimateArrgrate/tabs/popup/EstimateSubmitArrgrateSTCDetailPopup.vue'),
);
const submitArrgrateProjectSTCDetailPopup = defineAsyncComponent(() =>
  import('@/views/submit/popup/popupDetail/SubmitArrgrateProjectSTCDetailPopup.vue'),
);
const submitArrgrateInvestSTCBudgetPopup = defineAsyncComponent(() =>
  import('@/views/submit/popup/popupDetail/SubmitArrgrateInvestSTCBudgetPopup.vue'),
);
const submitArrgrateInvestSTCDetailPopup = defineAsyncComponent(() =>
  import('@/views/submit/popup/popupDetail/SubmitArrgrateInvestSTCDetailPopup.vue'),
);
const submitEstimateArrgrateExpenseRegularDetailSTC = defineAsyncComponent(() =>
  import('@/views/submit/popup/popupDetail/SubmitEstimateArrgrateExpenseRegularDetailSTC.vue'),
);
const submitEstimateArrgrateExpenseOtherDetailSTC = defineAsyncComponent(() =>
  import('@/views/submit/popup/popupDetail/SubmitEstimateArrgrateExpenseOtherDetailSTC.vue'),
);
const submitEstimateArrgrateOtherSTCExplanationPopup = defineAsyncComponent(() =>
  import('@/views/submit/popup/popupDetail/SubmitEstimateArrgrateOtherSTCExplanationPopup.vue'),
);
const submitArrgrateCalculationBasisSTCDetailPopup = defineAsyncComponent(() =>
  import('@/views/submit/popup/popupDetail/SubmitArrgrateCalculationBasisSTCDetailPopup.vue'),
);
const submitArrgrateExplanationRegularSTCPopup = defineAsyncComponent(() =>
  import('@/views/submit/popup/SubmitArrgrateExplanationRegularSTCPopup.vue'),
);
const submitArrgrateBudgetDetailAgencySTC = defineAsyncComponent(() =>
  import('@/views/submit/estimateArrgrateBudget/SubmitArrgrateBudgetDetailAgencySTC.vue'),
);
const submitEstimateArrgrateRevenueOtherStc = defineAsyncComponent(() =>
  import('@/views/submit/popup/popupDetail/SubmitEstimateArrgrateRevenueOtherStc.vue'),
);
const submitEstimateArrgrateRevenueBudgetStc = defineAsyncComponent(() =>
  import('@/views/submit/popup/popupDetail/SubmitEstimateArrgrateRevenueBudgetStc.vue'),
);
const submitEstimateArrgrateRevenueBudgetStcDetailAgency = defineAsyncComponent(() =>
  import('@/views/submit/popup/popupDetail/SubmitEstimateArrgrateRevenueBudgetStcDetailAgency.vue'),
);
const submitArrgrateExplanationStcPopup = defineAsyncComponent(() =>
  import('@/views/submit/popup/popupDetail/SubmitArrgrateExplanationStcPopup.vue'),
);



export function estimateArrgrateRegister(app) {
  app.component('estimateArrgrateProject', estimateArrgrateProject);
  app.component('estimateArrgrateRegular', estimateArrgrateRegular);
  app.component('estimateArrgrateRegularSTC', estimateArrgrateRegularSTC);
  app.component('estimateArrgrateMaEstimateArrgrateExpenseInveststerTab', estimateArrgrateMasterTab);
  app.component('estimateArrgrateDetailTab', estimateArrgrateDetailTab);
  app.component('estimateArrgrateExplanation', estimateArrgrateExplanation);
  app.component('estimateArrgrateReferencesTab', estimateArrgrateReferencesTab);
  app.component('EstimateArrgrateRegularField', estimateArrgrateRegularField);
  app.component('estimateArrgrateRevenueOther', estimateArrgrateRevenueOther);
  app.component('estimateArrgrateRevenueOtherSTC', estimateArrgrateRevenueOtherSTC);
  app.component('estimateArrgrateRegularSummaryExplanation', estimateArrgrateRegularSummaryExplanation);
  app.component('estimateArrgrateRegularSummaryExplanationSTC', estimateArrgrateRegularSummaryExplanationSTC);

  app.component('EstimateArrgrateRevenueOtherDetail', EstimateArrgrateRevenueOtherDetail);
  app.component('EstimateArrgrateExpenseOtherDetail', EstimateArrgrateExpenseOtherDetail);
  app.component('SummaryEstimateArrgrateBudgetDetail', SummaryEstimateArrgrateBudgetDetail);
  app.component('SummaryEstimateArrgrateBudgetDetailAgency', SummaryEstimateArrgrateBudgetDetailAgency);

  app.component('EstimateArrgrateExplanationPopup', estimateArrgrateExplanationPopup);
  app.component('EstimateDetailArrgrateExplanationPopup', estimateDetailArrgrateExplanationPopup);
  app.component('EstimateArrgrateExpenseOther', EstimateArrgrateExpenseOther);
  app.component('EstimateArrgrateExpenseOtherSTC', EstimateArrgrateExpenseOtherSTC);
  app.component('EstimateArrgrateOtherExplanationPopup', EstimateArrgrateOtherExplanationPopup);
  app.component('EstimateArrgrateOtherSTCExplanationPopup', EstimateArrgrateOtherSTCExplanationPopup);
  app.component('EstimateArrgrateOtherExplanationSTCPopup', EstimateArrgrateOtherExplanationSTCPopup);
  app.component('EstimateArrgrateExpenseInvest', EstimateArrgrateExpenseInvest);
  app.component('EstimateArrgrateExpenseInvestSTC', EstimateArrgrateExpenseInvestSTC);
  app.component('EstimateArrgrateBudget', EstimateArrgrateBudget);
  app.component('EstimateArrgrateBudgetSTC', EstimateArrgrateBudgetSTC);
  app.component('EstimateArrgrateBudgetDetail', EstimateArrgrateBudgetDetail);
  app.component('EstimateArrgrateBudgetDetailAgency', EstimateArrgrateBudgetDetailAgency);
  app.component('ArrgrateBudgetDetailAgencySTC', ArrgrateBudgetDetailAgencySTC);

  app.component('SummaryEstimateArrgrateExpenseInvest', SummaryEstimateArrgrateExpenseInvest);
  app.component('SummaryEstimateArrgrateCalculationBasisDetail', SummaryEstimateArrgrateCalculationBasisDetail);
  app.component('SummaryEstimateArrgrateExpenseProjectDetail', SummaryEstimateArrgrateExpenseProjectDetail);

  app.component('SummaryEstimateArrgrateRevenueBussinessDetail', summaryEstimateArrgrateRevenueBussinessDetail); //
  app.component('SummaryEstimateArrgrateExpenseBussinessDetail', summaryEstimateArrgrateExpenseBussinessDetail);
  app.component('SummaryEstimateArrgrateRevenueFeesDetail', summaryEstimateArrgrateRevenueFeesDetail);
  app.component('SummaryEstimateArrgrateExpenseFeesDetail', summaryEstimateArrgrateExpenseFeesDetail);

  app.component('SummaryEstimateArrgrateExpenseRegularDetail', SummaryEstimateArrgrateExpenseRegularDetail);
  app.component('SummaryEstimateArrgrateExpenseInvestWideDetail', summaryEstimateArrgrateExpenseInvestWideDetail);
  app.component('SummaryEstimateArrgrateExpenseProjectWideDetail', summaryEstimateArrgrateExpenseProjectWideDetail);
  app.component('SummaryEstimateArrgrateExpenseRegularWideDetail', summaryEstimateArrgrateExpenseRegularWideDetail);
  app.component('SummaryEstimateArrgrateCalculationBasisWideDetail', summaryEstimateArrgrateCalculationBasisWideDetail);

  app.component(
    'SummaryEstimateArrgrateRevenueBudgetStcDetailAgency',
    summaryEstimateArrgrateRevenueBudgetStcDetailAgency,
  );
  app.component('SummaryEstimateArrgrateRevenueBudgetStc', summaryEstimateArrgrateRevenueBudgetStc);
  app.component('SummaryEstimateArrgrateRevenueOtherStc', summaryEstimateArrgrateRevenueOtherStc);

  app.component('estimateArrgrateSubmitDetailPopup', estimateArrgrateSubmitDetailPopup);
  app.component('explanationSalaryPopup', explanationSalaryPopup);
  app.component('explanationSalaryArrgratePopup', explanationSalaryArrgratePopup);
  app.component('explanationSalarySTCPopup', explanationSalarySTCPopup);
  app.component('explanationSalarySummary', estimateArrgrateExplanationSalarySummary);
  app.component('explanationSalarySummarySTC', estimateArrgrateExplanationSalarySummarySTC);
  app.component('SubmitArrgrateInvestBudgetDetail', submitArrgrateInvestBudgetDetail);
  app.component('SubmitArrgrateCalculationBasisDetail', submitArrgrateCalculationBasisDetail);
  app.component('SubmitArrgrateRegularExpenseDetail', submitArrgrateRegularExpenseDetail);
  app.component('SubmitArrgrateBudgetDetail', submitArrgrateBudgetDetail);
  app.component('SubmitArrgrateBudgetDetailAgency', submitArrgrateBudgetDetailAgency);
  app.component('SubmitArrgrateExplanationRegularPopup', SubmitArrgrateExplanationRegularPopup);
  app.component('SubmitArrgrateRevenueOtherDetail', submitArrgrateRevenueOtherDetail);
  app.component('SubmitArrgrateExpenseOtherDetail', submitArrgrateExpenseOtherDetail);
  app.component('SubmitArrgrateInvestDetail', submitArrgrateInvestDetail);
  app.component('AuditReceiveArrgrateInvestDetail', auditReceiveArrgrateInvestDetail);
  app.component('AuditReceiveArrgrateInvestBudgetDetail', auditReceiveArrgrateInvestBudgetDetail);
  app.component('AuditReceiveArrgrateProjectDetail', auditReceiveArrgrateProjectDetail);
  app.component('SubmitArrgrateProjectDetail', submitArrgrateProjectDetail);
  app.component('AuditReceiveArrgrateCalculationBasisDetail', auditReceiveArrgrateCalculationBasisDetail);
  app.component('AuditReceiveArrgrateRegularDetail', AuditReceiveArrgrateRegularDetail);
  app.component('AuditReceiveArrgrateExplanationRegularPopup', AuditReceiveArrgrateExplanationRegularPopup);
  app.component('SummaryEstimateArrgrateExpenseRegularDetailSTC', SummaryEstimateArrgrateExpenseRegularDetailSTC);
  app.component('EstimateArrgrateProjectSTC', EstimateArrgrateProjectSTC);

  app.component('SummaryEstimateArrgrateExpenseOtherDetailSTC', SummaryEstimateArrgrateExpenseOtherDetailSTC);
  app.component('SummaryEstimateArrgrateOtherSTCExplanationPopup', SummaryEstimateArrgrateOtherSTCExplanationPopup);
  app.component('ExplanationArrgratePopup', explanationArrgratePopup);
  app.component('SubmitExplanationArrgratePopup', submitExplanationArrgratePopup);
  app.component('EstimateFinanceThreeYearExpenseInvestDetail', EstimateFinanceThreeYearExpenseInvestDetail);
  app.component('AllocationImplementBudgetDetailAgency', AllocationImplementBudgetDetailAgency);
  app.component('AllocationImplementBudgetDetailAgencyPTC', AllocationImplementBudgetDetailAgencyPTC);
  app.component('estimateSubmitArrgrateSTCDetailPopup', estimateSubmitArrgrateSTCDetailPopup);
  app.component('SubmitArrgrateProjectSTCDetailPopup', submitArrgrateProjectSTCDetailPopup);
  app.component('SubmitArrgrateInvestSTCBudgetPopup', submitArrgrateInvestSTCBudgetPopup);
  app.component('SubmitArrgrateInvestSTCDetailPopup', submitArrgrateInvestSTCDetailPopup);
  app.component('SubmitEstimateArrgrateExpenseRegularDetailSTC', submitEstimateArrgrateExpenseRegularDetailSTC);
  app.component('SubmitEstimateArrgrateExpenseOtherDetailSTC', submitEstimateArrgrateExpenseOtherDetailSTC);
  app.component('SubmitEstimateArrgrateOtherSTCExplanationPopup', submitEstimateArrgrateOtherSTCExplanationPopup);
  app.component('SubmitArrgrateCalculationBasisSTCDetailPopup', submitArrgrateCalculationBasisSTCDetailPopup);
  app.component('SubmitArrgrateExplanationRegularSTCPopup', submitArrgrateExplanationRegularSTCPopup);
  app.component('SubmitArrgrateBudgetDetailAgencySTC', submitArrgrateBudgetDetailAgencySTC);
  app.component('SubmitEstimateArrgrateRevenueOtherStc', submitEstimateArrgrateRevenueOtherStc);
  app.component('SubmitEstimateArrgrateRevenueBudgetStc', submitEstimateArrgrateRevenueBudgetStc);
  app.component('SubmitEstimateArrgrateRevenueBudgetStcDetailAgency', submitEstimateArrgrateRevenueBudgetStcDetailAgency);
  app.component('SubmitArrgrateExplanationStcPopup', submitArrgrateExplanationStcPopup);
}
